var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap position-relative justify-content-between align-items-center container w-100"},_vm._l((_vm.casinoChips),function(chip,index){return _c('Chip',{key:index,class:{ 'chip-active': _vm.amount === chip.value },attrs:{"chip":chip},on:{"clicked":(c) => _vm.handleSelectionChip(c.number)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }